import { PlayCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "./constants";

const TIMESTAMPS = [
  { time: "00:40", topic: "How to know when upstander training is actually working" },
  { time: "03:45", topic: "How upstander training builds community" },
  { time: "07:05", topic: "What facilitators should keep in mind when delivering" },
  { time: "09:52", topic: "Responding when the organization doesn't fully support speaking up" },
  { time: "14:16", topic: "How to acknowledge and address the fear of speaking up" },
  { time: "17:23", topic: "Real results after the training" },
];

export const Experts = () => (
  <section className="py-24 lg:py-32" data-testid="experts-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 lg:grid-cols-12 lg:px-10">
      <Reveal className="lg:col-span-5">
        <div className="overflow-hidden rounded-[2rem] border border-navy/10 bg-navy shadow-[0_40px_80px_-30px_rgba(15,23,42,0.3)]">
          <video
            controls
            preload="none"
            poster={IMAGES.meeting}
            className="aspect-video w-full object-contain"
            data-testid="experts-video"
          >
            <source src="/videos/facilitator-tips.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </Reveal>
      <Reveal className="lg:col-span-7" delay={0.1}>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">Advice from expert facilitators</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
          Learn what really happens in the room — before you're in it.
        </h2>
        <p className="mt-6 max-w-2xl leading-relaxed text-navy/70 md:text-lg">
          Watch Catherine Mattice, CEO of Civility Partners, in conversation with expert
          facilitators Dr. Toni Herndon and Dr. Bob Berk, who have delivered this program to
          hundreds of learners across industries — including organizations navigating real
          resistance and complex cultural challenges.
        </p>
        <ul className="mt-8 space-y-3" data-testid="experts-timestamps">
          {TIMESTAMPS.map((t) => (
            <li key={t.time} className="flex items-center gap-4 rounded-xl border border-navy/10 bg-white px-5 py-3.5 transition-[border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-terra/50">
              <PlayCircle className="h-5 w-5 shrink-0 text-terra" aria-hidden="true" />
              <span className="font-mono text-sm font-semibold text-terra">{t.time}</span>
              <span className="text-sm text-navy/75">{t.topic}</span>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
